module.exports = {
  bulkUploadMapping: ($stateParams, Api) ->
    if $stateParams.bulkUploadMappingId?
      Api.BulkUploadMappings.get({ id: $stateParams.bulkUploadMappingId }).$promise
}
